const API_PREFIX = process.env.SAAS_API_PREFIX ?? "/api";
const MODEL_API_PREFIX = process.env.MODEL_API_PREFIX ?? "/model";

// S3 API
export const S3_UPLOAD_API = API_PREFIX + "/s3/upload";

// Job Config API
export const JOB_CONFIG_API = API_PREFIX + "/jobConfig";

export const SEASONALITY_API = MODEL_API_PREFIX + "/mmm/seasonality";
export const VARIABLE_SUMMARY_API = MODEL_API_PREFIX + "/mmm/variable-summary";
export const IMPUTE_API = MODEL_API_PREFIX + "/mmm/impute";
export const CORRELATION_MATRIX_API =
  MODEL_API_PREFIX + "/mmm/correlation-matrix";
export const VARIATION_INFLATION_FACTOR_API =
  MODEL_API_PREFIX + "/mmm/variance-inflation-factors";
export const OPTIMIZE_SPEND_API =
  MODEL_API_PREFIX + "/mmm/optimize_media_spend";
export const MMM_INPUT_DATA = MODEL_API_PREFIX + "/mmm/input-data";
export const CONTRIBUTION_PERC_API =
  MODEL_API_PREFIX + "/mmm/contribution-percentage";
export const SIMILARITY_MATRIX_API =
  MODEL_API_PREFIX + "/mmm/similarity-matrix";

// Geo Lift Apis
export const GEO_LIFT_MARKET_SELECTION =
  MODEL_API_PREFIX + "/geo_lift/market_selection";
export const GEO_LIFT_MARKET_SELECTION_SINGLE_SCM =
  MODEL_API_PREFIX + "/geo_lift/marketSelectionSingleSCM";
export const GEO_LIFT_GET_TEST_MARKET =
  MODEL_API_PREFIX + "/geo_lift/getTestMarkets";
export const GEO_LIFT_VALIDATE_DATA_API =
  MODEL_API_PREFIX + "/geo_lift/validateData";
export const GEO_LIFT_POWER_PLOT_API =
  MODEL_API_PREFIX + "/geo_lift/power_plot";
export const GEO_LIFT_POST_TEST_API = MODEL_API_PREFIX + "/geo_lift/post_test";
export const GEO_LIFT_POST_TEST_CACHE_API =
  MODEL_API_PREFIX + "/geo_lift/post_test_cache";
export const GEO_LIFT_AGGREGATE_LIFT_API =
  MODEL_API_PREFIX + "/geo_lift/aggregate_lift_percentage";
export const HUBSPOT_INTEGRATION_AUTH_API =
  API_PREFIX + "/integrations/hubspot/initiate-oauth";
export const HUBSPOT_INTEGRATION_CALLBACK_API =
  API_PREFIX + "/integrations/hubspot/oauth/callback";

// Shopify Integration APIs
export const SHOPIFY_INTEGRATION_AUTH_API =
  API_PREFIX + "/integrations/shopify/initiate-oauth";
export const SHOPIFY_INTEGRATION_CALLBACK_API =
  API_PREFIX + "/integrations/shopify/oauth/callback";

// Chat APIs
export const MMM_CHAT_API = MODEL_API_PREFIX + "/ai/chat/mmm";
